<button mat-flat-button color="primary" [disabled]="disabled" (click)="exportToExcel()" i18n="@@excel-export.button.label">
  excel-export.button.label
</button>
